module.exports = __webpack_public_path__ + "img/shopping-bag.7aae6d2b.png";